<template>
    <div
        v-if="Object.keys(planSeriesMapByStrategy).length"
        class="combo-card">
        <div class="card-head" @click="toggleCombo" v-if="showTitle">
            <div class="card-head-left">
                <span class="card-left"></span>
                <span class="card-title">
                    {{ cardTitle }}
                </span>
            </div>
            <span class="card-head-right">
                <img :src="upIcon" :class="expandValue ? 'spanReset' : 'spanRotate'" />
            </span>
        </div>
        <template v-if="expandValue">
            <div v-if="isAddOn" class="combo-type-describe">
                {{ $t('plan.data_add_on_plan_describe')}}
            </div>
            <ul>
                <template
                    v-for="(strategyMap,key) in planSeriesMapByStrategy"
                >
                    <series-card
                        v-if='showSeries(key)'
                        :key="key"
                        :isShowSelect="isShowSelect"
                        :planSeries="strategyMap"
                        :seriesKey="key"
                        :currSelectedPlanId='selectedPlanId'
                        :curr-sub-plan-id="currSubPlanId"
                        :curr-sub-expired="currSubExpired"
                        :subscribe-mode="subscribeMode"
                        :promotions="promotions"
                        @selected="handleSelectedChange"
                        @toggleSeries="handleComboToggle"
                    ></series-card>
                </template>

            </ul>
        </template>
    </div>
</template>
<script lang="ts">
import Vue, { PropType } from 'vue';
import coUp from '@/common/images/common/combo/co_up.svg';
import SeriesCard from './SeriesCard.vue';
import { ESeriesCategory, ESubscribeMode } from '@reolink-cloud/interface';
import { IPlanByStrategyAndCycle, productsManager } from '@/lib';

export default Vue.extend({
    components: {
        SeriesCard
    },
    props: {
        isExpand: {
            type: Boolean,
            default: false
        },
        showTitle: {
            type: Boolean,
            default: true,
        },
        type: {
            type: String as PropType<ESeriesCategory>,
            default: ESeriesCategory.CLOUD_STORAGE_DATA_PLAN
        },
        isShowSelect: {
            type: Boolean,
            default: false
        },
        country: {
            type: String,
            required: true
        },
        subscribeMode: {
            type: String as PropType<ESubscribeMode>,
            default: ESubscribeMode.CREATE
        },
        hasSubscribed: {
            type: Boolean,
            default: false
        },
        defaultSelectedPlan: String,
        currSubPlanId: String,
        currSubExpired: Boolean,
        currDeviceGroups: {
            type: Array as PropType<string[]>,
            required: true
        },
        promotions: Array
    },
    computed: {
        isAddOn(): boolean {

            return this.type === ESeriesCategory.CLOUD_DATA_ADD_ON_PLAN;

        },
        cardTitle(): string {

            switch ( this.type ) {

                case ESeriesCategory.CLOUD_STORAGE_PLAN:
                    return this.$t( 'plan.storage_plan_title' ) as string;
                case ESeriesCategory.CLOUD_STORAGE_DATA_PLAN:
                    return this.$t( 'plan.storage_data_plan_title' ) as string;
                case ESeriesCategory.CLOUD_DATA_PLAN:
                    return this.$t( 'plan.data_add_on_plan_title' ) as string;
                case ESeriesCategory.CLOUD_DATA_ADD_ON_PLAN:
                    return this.$t( 'plan.data_add_on_plan_title' ) as string;
                default:
                    return this.$t( 'plan.storage_data_plan_title' ) as string;

            }

        }

    },
    data() {

        let expandValue = this.isExpand;
        return {
            expandValue,
            upIcon: coUp,
            planSeriesMapByStrategy: {} as IPlanByStrategyAndCycle,
            selectedMap: {} as Record<string, string>,
            selectedPlanId: ''
        };

    },
    created() {

        this.initPlanSeries();

    },
    methods: {

        initPlanSeries() {

            let planSeriesMapByStrategy = productsManager.getPlanSeriesMap({
                category: this.type,
                country: this.country,
                defaultSelectedPlan: this.subscribeMode === ESubscribeMode.SWITCH ? this.defaultSelectedPlan : undefined,
                dropFreePlan: this.hasSubscribed && this.subscribeMode === ESubscribeMode.CREATE
            });

            // 通过赋值顺序改变排序
            const sortMap: Array<{ key: string; sort: number; }> = [];

            for ( let key of Object.keys( planSeriesMapByStrategy )) {

                this.selectedMap[key] = '';
                sortMap.push({
                    key: key,
                    sort: productsManager.getPlanSeriesByKey( key ).style['series.sort'] ?? 999
                });

            }

            sortMap.sort(( a, b ) => a.sort - b.sort );

            this.planSeriesMapByStrategy = sortMap.reduce<IPlanByStrategyAndCycle>(( acc, cur ) => {

                acc[cur.key] = planSeriesMapByStrategy[cur.key];
                return acc;

            }, {});

            for ( let key of Object.keys( this.selectedMap )) {

                this.selectedMap[key] = '';

            }

        },

        handleSelectedChange( value: string, selectedPlanId: string, seriesKey: string ): void {

            if ( !value ) {

                this.selectedMap[seriesKey] = '';
                this.checkSelectedId();
                return;

            }

            for ( const key of Object.keys( this.selectedMap )) {

                if ( seriesKey === key ) {

                    this.selectedMap[key] = selectedPlanId;

                } else {

                    this.selectedMap[key] = '';

                }

            }

            this.checkSelectedId();

        },

        checkSelectedId() {

            let currentSelectId = '';

            for ( const value of Object.values( this.selectedMap )) {

                if ( value ) {

                    currentSelectId = value;

                }

            }
            this.selectedPlanId = currentSelectId;

        },

        toggleCombo() {

            this.expandValue = !this.expandValue;
            this.handleComboToggle();

        },

        handleComboToggle() {

            this.$emit( 'toggleCombo' );

        },

        showSeries( seriesKey: string ): boolean {

            const seriesInfo = productsManager.getPlanSeriesByKey( seriesKey );

            if ( this.currDeviceGroups.includes( seriesInfo.deviceGroup ) || this.currDeviceGroups.length === 0 ) {

                return true;

            }
            return false;

        }
    },
    watch: {
        isExpand( value ) {

            this.expandValue = value;

        },
        selectedPlanId( newVal ) {

            this.$emit( 'change', newVal );

        },
        country() {

            this.initPlanSeries();
            this.checkSelectedId();

        },
    },
});
</script>

<style lang="less" scoped>
.combo-card {
    padding: @combo-card-padding;
    background-color: @bg_02;
    @media @snapeak_mobile {
        padding: @combo-card-padding-mobile;
    }
    .card-head{
        display: flex;
        align-items: center;
        justify-content: space-between;
        cursor: @combo-card-title-cursor;
        .card-head-left {
            display: flex;
            align-items: center;
            gap: 8px;
            .card-left {
                display: @combo-card-title-display;
                width: 5px;
                height: 24px;
                border-radius: 0px 39px 56px 0px;
                background: @brand_light;
                @media @snapeak_mobile {
                    height: 20px;
                }
            }
            .card-title {
                font-family: @font_02;
                font-size: @combo-card-title-font-size;
                font-weight: 500;
                line-height: 1.2;
                letter-spacing: 0em;
                color: @combo-card-title-color;
                @media @snapeak_pc{
                    &:hover{
                        color: @combo-card-title-hover-color;
                    }
                }
                @media @snapeak_mobile {
                    font-size: @combo-card-title-font-size-mobile;
                }

            }
        }

        .card-head-right{
            display: @combo-card-title-display;
            img {
                @media @snapeak_mobile {
                    width: 20px;
                    height: 20px;
                }
            }
        }
    }
    .combo-type-describe {
        font-family: @font_02;
        font-size: 16px;
        font-weight: 500;
        line-height: 20px;
        letter-spacing: 0em;
        color: @font_secondary;
        margin-top: 8px;
    }

    ul {
        margin-top: 24px;
    }

    .spanRotate {
        transform: rotate(180deg);
        -webkit-transform: rotate(180deg);
        transition: transform .5s;
    }

    .spanReset {
        transform: rotate(0deg);
        -webkit-transform: rotate(0deg);
        transition: transform .5s;
    }

}
</style>
